const API_URL_KEY = 'zt_dashboard_api_url'

/** 返回用户显式保存的后端 API 基址（未配置时为空字符串） */
export function getStoredApiBaseUrl(): string {
  try {
    const stored = localStorage.getItem(API_URL_KEY)
    if (stored?.trim()) return stored.trim().replace(/\/+$/, '')
  } catch {
    // ignore
  }
  return ''
}

/** 保存后端 API 基址；传空值则清除保存的配置 */
export function setApiBaseUrl(url: string): void {
  try {
    const normalized = url.trim().replace(/\/+$/, '')
    if (normalized) localStorage.setItem(API_URL_KEY, normalized)
    else localStorage.removeItem(API_URL_KEY)
  } catch {
    // ignore
  }
}

/** 返回生效的后端 API 基址：浏览器本地保存值 > 同源 /api/v1 */
export function getApiBaseUrl(): string {
  const stored = getStoredApiBaseUrl()
  if (stored) return stored
  return '/api/v1'
}

/** 由当前 API 基址推导 WebSocket 基址 */
export function getWsBaseUrl(): string {
  const url = new URL(
    getApiBaseUrl(),
    typeof window !== 'undefined' ? window.location.origin : 'http://localhost',
  )
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:'
  return url.toString()
}
